// Typelizer digest fd8a39c745e7c14eaa960fd70bbf6c3b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** PATCH /c/:company_id/payment_matching_rules/:id/accept */
  accept: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/payment_matching_rules/:id/accept', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/payment_matching_rules/:id/reject */
  reject: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/payment_matching_rules/:id/reject', params, options),
    method: 'delete',
  }),

  /** PATCH /c/:company_id/payment_matching_rules/:id/disable */
  disable: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/payment_matching_rules/:id/disable', params, options),
    method: 'patch',
  }),

  /** PATCH /c/:company_id/payment_matching_rules/:id/reenable */
  reenable: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/payment_matching_rules/:id/reenable', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/payment_matching_rules/reject_all */
  rejectAll: (options?: RouteOptions): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/payment_matching_rules/reject_all', {}, options),
    method: 'delete',
  }),

  /** GET /c/:company_id/payment_matching_rules */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/payment_matching_rules', {}, options),
    method: 'get',
  }),

  /** POST /c/:company_id/payment_matching_rules */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/payment_matching_rules', {}, options),
    method: 'post',
  }),

  /** GET /c/:company_id/payment_matching_rules/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/payment_matching_rules/:id', params, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/payment_matching_rules/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/payment_matching_rules/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/payment_matching_rules/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/payment_matching_rules/:id', params, options),
    method: 'delete',
  }),
}
